import { IDataComparable } from '../../contracts/data-comparable.js';
import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, isSameList, SerializationContext, SerializedData } from '../dto/dto.js';

export class PointOfInterestCategory implements IDataComparable {
  constructor(
    public readonly categoryId: string,
    public readonly pointsOfInterest: string[],
  ) {}

  isSame(other: PointOfInterestCategory): boolean {
    if(this === other) {
      return true;
    }

    return other.categoryId === this.categoryId &&
          isSameList(other.pointsOfInterest, this.pointsOfInterest);
  }
}

export class PointOfInterestDistribution extends DataModel {
  static readonly TYPE_ID: string = 'cabbe5ef7f094d6e9b9accba32256840';

  constructor(
    public readonly localityId: string,
    public readonly pointsOfInterest: PointOfInterestCategory[],
  ) {
    super();
  }

  get $typeId() {
    return PointOfInterestDistribution.TYPE_ID;
  }

  get uniqueId(): string {
    return this.localityId;
  }

  static fromMap(context: SerializationContext, map: SerializedData): PointOfInterestDistribution {
    const categoryMap: Map<string, string[]> = MapUtils.getMap(map, 'pointsOfInterest', (k, v) => {
      return { key: k, value: v as string[] };
    });
    const pointsOfInterest: PointOfInterestCategory[] = [];

    categoryMap.forEach((value: string[], key: string) => {
      pointsOfInterest.push(new PointOfInterestCategory(key, value));
    });

    return new PointOfInterestDistribution(
        MapUtils.get<string>(map, 'localityId'),
        pointsOfInterest,
    );
  }

  toMap(context: SerializationContext): SerializedData {
    const pointsOfInterest: SerializedData = {};
    for(const category of this.pointsOfInterest) {
      pointsOfInterest[category.categoryId] = category.pointsOfInterest;
    }

    return {
      'localityId': this.localityId,
      'pointsOfInterest': pointsOfInterest,
    };
  }

  clone(): this {
    return new PointOfInterestDistribution(
        this.localityId,
        this.pointsOfInterest,
    ) as this;
  }

  isSame(other: PointOfInterestDistribution): boolean {
    if(this === other) {
      return true;
    }

    return other.localityId === this.localityId &&
          isSameList(other.pointsOfInterest, this.pointsOfInterest);
  }
}

export class PointOfInterestDistributionBuilder extends DataModelBuilder<PointOfInterestDistribution> {
  build(context: SerializationContext, map: SerializedData): PointOfInterestDistribution {
    return PointOfInterestDistribution.fromMap(context, map);
  }
}
